/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

export const errorDetails = [
    { 100: 'Continue' },
    { 101: 'Switching Protocols' },
    { 102: 'Processing' }, // WebDAV; RFC 2518
    { 103: 'Early Hints' }, // RFC 8297
    { 200: 'OK' },
    { 201: 'Created' },
    { 202: 'Accepted' },
    { 203: 'Non-Authoritative Information' }, // since HTTP/1.1
    { 204: 'No Content' },
    { 205: 'Reset Content' },
    { 206: 'Partial Content' }, // RFC 7233
    { 207: 'Multi-Status' }, // WebDAV; RFC 4918
    { 208: 'Already Reported' }, // WebDAV; RFC 5842
    { 226: 'IM Used' }, // RFC 3229
    { 300: 'Multiple Choices' },
    { 301: 'Moved Permanently' },
    { 302: 'Found' }, // Previously "Moved temporarily"
    { 303: 'See Other' }, // since HTTP/1.1
    { 304: 'Not Modified' }, // RFC 7232
    { 305: 'Use Proxy' }, // since HTTP/1.1
    { 306: 'Switch Proxy' },
    { 307: 'Temporary Redirect' }, // since HTTP/1.1
    { 308: 'Permanent Redirect' }, // RFC 7538
    { 400: 'Oops , Please contact Helpdesk or refresh you browser' },
    { 401: 'Oops, something went wrong, con' }, // RFC 7235
    { 402: 'Payment Required' },
    { 403: 'Forbidden' },
    { 404: 'Not Found' },
    { 405: 'Method Not Allowed' },
    { 406: 'Not Acceptable' },
    { 407: 'Proxy Authentication Required' }, // RFC 7235
    { 408: 'Request Timeout' },
    { 409: 'Conflict' },
    { 410: 'Gone' },
    { 411: 'Length Required' },
    { 412: 'Precondition Failed' }, // RFC 7232
    { 413: 'The data size exceeded maximum limit contact helpdesk' }, // RFC 7231
    { 414: 'URI Too Long' }, // RFC 7231
    { 415: 'Unsupported Media Type' }, // RFC 7231
    { 416: 'Range Not Satisfiable' }, // RFC 7233
    { 417: 'Expectation Failed' },
    { 418: 'I\'m a teapot' }, // RFC 2324, RFC 7168
    { 421: 'Misdirected Request' }, // RFC 7540
    { 422: 'Unprocessable Entity' }, // WebDAV; RFC 4918
    { 423: 'Locked' }, // WebDAV; RFC 4918
    { 424: 'Failed Dependency' }, // WebDAV; RFC 4918
    { 425: 'Too Early' }, // RFC 8470
    { 426: 'Upgrade Required' },
    { 428: 'Precondition Required' }, // RFC 6585
    { 429: 'Too Many Requests' }, // RFC 6585
    { 431: 'Request Header Fields Too Large' }, // RFC 6585
    { 451: 'Unavailable For Legal Reasons' }, // RFC 7725
    { 500: 'Oops, Something went wrong contact Helpdesk' },
    { 501: 'Not Implemented' },
    { 502: 'Oops, Something went wrong contact Helpdesk' },
    { 503: 'Oops, Something went wrong contact Helpdesk' },
    { 504: 'Oops, Please refresh the browser' },
    { 505: 'HTTP Version Not Supported' },
    { 506: 'Variant Also Negotiates' }, // RFC 2295
    { 507: 'Insufficient Storage' }, // WebDAV; RFC 4918
    { 508: 'Loop Detected' }, // WebDAV; RFC 5842
    { 510: 'Not Extended' }, // RFC 2774
    { 511: 'Network Authentication Required' }, // RFC 6585
];

/**
 * 
 * To get status details.
 * 
 * @param {number|string} code Error code (e.g 200)
 * 
 * @returns OK
 */
export const getResponseDetails = (code) => {
    const index = errorDetails.findIndex(x => x[code]);
    return index !== -1 ? errorDetails[index][code] : "Oops, Something went wrong contact Helpdesk";
}
